module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/contest_stats/nba/survive/2_rebounds&assists-989df3e975b8320fe1fe8e39eb569113.svg";